import React, { Component } from 'react'
import { connect } from 'react-redux'
import css from './styles.scss'
import globalCss from '../../../../scss/global.scss'

export class SampleFromAnonymousEditor extends Component {
  constructor ({ variable }) {
    super()
    this.state = {
      options: variable.args[0] || [],
      sampleSize: variable.args[1] || 1
    }
  }

  updateOption = (value, idx) => {
    const updatedOptions = [...this.state.options]
    updatedOptions[idx] = value
    this.setState({
      options: updatedOptions
    })
  }

  handleAddOption = () => {
    const { options } = this.state
    this.setState({
      options: [...options, '']
    })
  }

  handleUpdateSampleSize = evt => {
    if (parseInt(evt.target.value, 10) > -1 || evt.target.value.length < 1) {
      this.setState({
        sampleSize: evt.target.value
      })
    }
  }

  removeEntry (idx) {
    const options = [...this.state.options]
    options.splice(idx, 1)
    this.setState({
      options
    })
  }

  componentWillReceiveProps (nextProps) {
    const { report, save, variableName } = this.props
    const { sampleSize } = this.state
    if (nextProps.report === true && report === false) {
      save(variableName, [this.state.options, sampleSize])
    }
  }

  render () {
    const { app: { primaryColor } } = this.props
    const { options, sampleSize } = this.state
    const choices = options.map((option, i) => {
      return (
        <li key={i} className={css.entry}>
          <button type='button' style={{ color: primaryColor }} className={css.del} onClick={() => this.removeEntry(i)}>
            <i className={globalCss.iconMinusCircled} />
          </button>
          <input
            className={css.option}
            type='text'
            value={option}
            onChange={evt => { this.updateOption(evt.target.value, i) }}
          />
        </li>
      )
    })
    return (
      <div>
        <ul>
          {choices}
        </ul>
        <button
          className={css.add}
          onClick={this.handleAddOption}
          type='button'
          style={{ backgroundColor: primaryColor }}
        >
          <i className={globalCss.iconPlus} />
        </button>
        <div>
          <label className={css.label}>
            Sample Size:
            <input
              type='number'
              value={sampleSize}
              onChange={this.handleUpdateSampleSize}
              className={css.option}
            />
          </label>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  const { app } = state
  return {
    app
  }
}

export default connect(mapStateToProps)(SampleFromAnonymousEditor)



// WEBPACK FOOTER //
// /app/js/components/EditVariable/SampleFromAnonymousEditor/index.js